import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetPublishedLessonActivitiesByVersionQuery,
  GetPublishedLessonActivitiesByVersionQueryVariables,
} from './get-published-lesson-activities-by-version.graphql.generated';
import { GET_PUBLISHED_LESSON_ACTIVITIES_BY_VERSION } from './get-published-lesson-activities-by-version.graphql';
import { LanguageCodes } from 'global/constants';

export const useGetPublishedLessonActivitiesByVersion = ({
  version,
  skip,
  classId,
  fetchPolicy,
  isSignedIn,
  language,
  onCompleted,
}: {
  version?: string | null;
  skip?: boolean;
  classId: number | null;
  fetchPolicy?: WatchQueryFetchPolicy;
  isSignedIn: boolean;
  language?: LanguageCodes;
  onCompleted?: (res: GetPublishedLessonActivitiesByVersionQuery) => void;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetPublishedLessonActivitiesByVersionQuery,
    GetPublishedLessonActivitiesByVersionQueryVariables
  >(
    GET_PUBLISHED_LESSON_ACTIVITIES_BY_VERSION,
    {
      fetchPolicy,
      skip: !version || skip,
      variables: {
        input: {
          version: version || '',
          language,
          classId: classId ?? null,
        },
      },
      onCompleted: res => onCompleted?.(res),
    },
    isSignedIn
  );

  return {
    data,
    loading,
    error,
  };
};
